module.exports = __webpack_public_path__ + "static/bg-train-d98e6753d03b623bc8c51d88cd2cfcdd.png";